import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useObjetivos } from "../../../../context/SuperAdmin/OASContexts/ObjetivosContext";
import { EditObjetivoFields } from "../../../../interfaces/SuperAdmin/Pages/iDataObjetivos";
const EditObjetivoModal = () => {
  const {
    isEditModalOpen,
    toggleEditModal,
    toEditObjetivo,
    objetivoEdit,
    isEditing,
    tipos,
    isLoadingTipos,
  } = useObjetivos();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<EditObjetivoFields>();

  // Función para manejar el envío del formulario
  const handleSubmitForm = (data: EditObjetivoFields) => {
    if (toEditObjetivo) {
      console.log(data);

      objetivoEdit(data, toEditObjetivo.id_objetivo);
    }
  };

  const handleClose = () => {
    if (!isEditing) {
      reset();
      toggleEditModal(false);
    }
  };

  useEffect(() => {
    if (toEditObjetivo) {
      reset({
        nombre: toEditObjetivo.nombre,
        codigo: toEditObjetivo.codigo,
        id_tipo: toEditObjetivo.id_tipo,
      });
    }
  }, [toEditObjetivo]);

  return (
    <Modal
      open={isEditModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        {isLoadingTipos ? (
          <Typography
            id="edit-subscription-modal-title"
            justifyContent={"center"}
            sx={{
              width: 1,
              textAlign: "center",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            Cargando...
          </Typography>
        ) : (
          <>
            <Typography variant="h6" component="h2">
              Editar objetivo
            </Typography>

            {/* Campo Nombre */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Contenido
              </Typography>
              <Controller
                name="nombre"
                control={control}
                rules={{ required: "El nombre es obligatorio" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    margin="normal"
                    error={!!errors.nombre}
                    helperText={errors.nombre?.message}
                    disabled={isEditing}
                    multiline
                    minRows={3}
                    maxRows={8}
                  />
                )}
              />
            </Box>

            {/* Campo Código */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Código
              </Typography>
              <Controller
                name="codigo"
                control={control}
                rules={{ required: "El código es obligatorio" }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    margin="normal"
                    error={!!errors.codigo}
                    helperText={errors.codigo?.message}
                    disabled={isEditing}
                  />
                )}
              />
            </Box>

            {/* Campo Tipo */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Tipo
              </Typography>
              <FormControl error={!!errors.id_tipo}>
                <Controller
                  name="id_tipo"
                  control={control}
                  rules={{ required: "El tipo es obligatorio" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      value={field.value || ""}
                      fullWidth
                      disabled={isEditing}
                    >
                      {tipos.map((tipo) => (
                        <MenuItem key={tipo.id_tipo} value={tipo.id_tipo}>
                          {tipo.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
                <FormHelperText>{errors.id_tipo?.message}</FormHelperText>
              </FormControl>
            </Box>

            <Box sx={{ mt: 3, textAlign: "right" }}>
              <Button
                variant="contained"
                sx={{ background: "#336B87" }}
                disabled={isEditing}
                type="submit"
              >
                {isEditing ? "Guardando" : "Guardar"}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default EditObjetivoModal;
